import { createRadioFilter } from './factories';
import type { FilterRegistry } from './types';

/**
 * PD-16162 — the Schedule tab's filters. The Schedule used to carry a
 * Today / This Week toggle bar and a row of rep buttons of its own; both are
 * registered filters now, so they sit in the standard filter bar, count on
 * the filter button and can be saved with a view like any other filter.
 *
 * `scheduleWindow` is a date choice the BROWSER resolves: "today" is a local
 * date, so the list's query function turns the chosen window into `from` /
 * `to` before the request leaves, and the server never has to guess the
 * rep's day. Its `queryMapping` names the trip date only so the registry has
 * a column to attribute it to; no SQL is generated from it.
 */
export const salesTripFilters: FilterRegistry = {
	scheduleWindow: createRadioFilter({
		label: 'When',
		options: [
			{ id: 'today', label: 'Today' },
			{ id: 'week', label: 'This Week' },
		],
		defaultValue: { id: 'today', label: 'Today' },
		objectTable: 'sales_trip',
		fieldName: 'tripDate',
		listKeys: ['sales_trip_schedule'],
	}),

	scheduleStatus: createRadioFilter({
		label: 'Stop status',
		options: [
			{ id: 'planned', label: 'Still to visit' },
			{ id: 'visited', label: 'Visited' },
			{ id: 'skipped', label: 'Skipped' },
			{ id: 'missed', label: 'Missed' },
			{ id: 'rescheduled', label: 'Rescheduled' },
		],
		objectTable: 'sales_trip_stop',
		fieldName: 'status',
		listKeys: ['sales_trip_schedule'],
		colorScheme: 'green',
	}),

	scheduleRep: {
		type: 'multi-select',
		label: 'Salesperson',
		placeholder: 'Search users...',
		colorScheme: 'purple',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: 'workdUserId' as keyof unknown,
			primary: 'display_name' as keyof unknown,
		},
		apiEndpoint: '/users',
		queryParamName: 'scheduleRep',
		multiple: true,
		queryMapping: {
			objectTable: 'sales_trip',
			fieldName: 'salespersonUserId',
			joinType: 'direct',
		},
		format: 'array',
		// A trip belongs to a rep by Workd user id (the global keyspace), not
		// by the tenant user row, so that is the id sent.
		valueExtractor: {
			property: 'workdUserId',
		},
		listKeys: ['sales_trip_schedule'],
	},
};
